import React from 'react';

import Modal from 'components/Common/Modal';
import Button from 'components/Button';
import { ButtonType } from 'components/Button/Button';
import { ContactType } from 'handlers/yourContact';

import styles from './ResendConfirmationModal.module.scss';

const contactTypeDetails = {
  [ContactType.Email]: {
    label: 'Email Address',
    goBackLabel: 'Email',
  },
  [ContactType.Phone]: {
    label: 'Phone Number',
    goBackLabel: 'Phone',
  },
};

export interface ResendConfirmationModalProps {
  isOpen: boolean;
  contactValue: string;
  contactType: ContactType;
  onConfirm: () => void;
  onGoBack: () => void;
  onClose: () => void;
}

const ResendConfirmationModal = ({
  isOpen,
  contactValue,
  contactType,
  onConfirm,
  onGoBack,
  onClose,
}: ResendConfirmationModalProps) => {
  if (!isOpen) return null;

  const { label, goBackLabel } = contactTypeDetails[contactType];

  return (
    <Modal closeModal={onClose}>
      <div className={styles.content}>
        <h3>Confirm {label}</h3>

        <p className={styles.message}>
          You're about to receive a new verification code. Please confirm this is the correct {label.toLowerCase()}:
        </p>

        <div className={styles.valueContainer}>
          <span className={styles.value}>{contactValue}</span>
        </div>

        <p className={styles.note}>If the {label.toLowerCase()} is incorrect, please go back to modify it.</p>

        <div className={styles.buttonContainer}>
          <Button onClick={onConfirm}>Resend Code</Button>

          <Button type={ButtonType.Secondary} onClick={onGoBack}>
            Go Back & Modify {goBackLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResendConfirmationModal;
